<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div class="login d-flex flex-column justify-center align-center">
      <v-card
        class="
          d-flex
          flex-column
          justify-center
          align-center
          pa-6
          py-10
          mx-2
          my-4
        "
        elevation="0"
      >
        <img :src="logoUrl" style="width: 150px" />
        <v-form
          v-model="form"
          class="mx-md-5 mt-10"
          @submit.prevent="signupSubmit"
        >
          <v-text-field
            v-model="email"
            name="E-Mail Address"
            label="E-Mail Address"
            :rules="emailRules"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="username"
            name="Username"
            label="Username"
            :rules="usernameRules"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            name="Password"
            label="Password"
            type="password"
            :rules="passwordRules"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-text-field
            v-model="phone"
            name="Phone Number"
            label="Phone Number"
            :rules="phMobileRules"
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>

          <!-- <v-checkbox
            v-model="managerAccount"
            label="Create a manager account"
            dark
          ></v-checkbox> -->
          <v-radio-group v-model="managerAccount">
            <v-radio label="Property Manager" value="lessor"></v-radio>
            <v-radio label="Tenant" value="tenant"></v-radio>
          </v-radio-group>

          <v-checkbox v-model="agreeTerms" :rules="termsRules">
            <template v-slot:label>
              <p>
                I agree to the
                <a @click="openTermsAndConditions"> Terms and Conditions </a>
                and
                <a @click="openPrivacyPolicy"> Privacy Policy </a>
              </p>
            </template>
          </v-checkbox>

          <v-btn
            class="mt-5"
            block
            rounded
            depressed
            color="primary"
            :disabled="!agreeTerms || !form"
            type="loginSubmit"
            >Sign Up</v-btn
          >
          <div class="link">
            <a class="text-tiny" @click="redirectLogin">Sign In Here</a>
          </div>
          <!-- <input type="email" placeholder="E-Mail" v-model="email">
          <input type="password" placeholder="Password" v-model="password"> -->
          <!-- <button type="submit">Login</button> -->
        </v-form>
      </v-card>
    </div>
    <TermsAndConditions ref="termsAndConditions"></TermsAndConditions>
    <PrivacyPolicy ref="privacyPolicy"></PrivacyPolicy>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackMessage }}
      <v-btn color="primary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TermsAndConditions from '../components/usage/TermsAndConditions.vue'
import PrivacyPolicy from '../components/usage/PrivacyPolicy.vue'

export default {
  components: {
    TermsAndConditions,
    PrivacyPolicy
  },
  data() {
    return {
      username: '',
      password: '',
      email: '',
      phone: '',
      // firstName: '',
      // lastName: '',
      managerAccount: 'lessor',
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`,
      version: process.env.VUE_APP_VERSION,
      snackMessage: '',
      snackbar: false,
      timeout: 5000,
      emailRules: [
        (v) => validateEmail(v) || 'E-Mail must be a valid e-mail format'
      ],
      usernameRules: [
        (v) => v.length >= 5 || 'Username must be 5 characters or longer'
      ],
      passwordRules: [
        (v) => !!v || 'Password is Required',
        (v) => {
          const pattern = /(?=.*\d)(?=.*[A-Za-z])/
          return (
            pattern.test(v) ||
            'Password must contain at least one number and letter'
          )
        },
        (v) => v.length >= 8 || 'Password must contain at least 8 characters'
      ],
      termsRules: [
        (v) => v == true || 'You must agree to the Terms and Conditions'
      ],
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        }
      ],
      agreeTerms: false,
      form: false,
      loading: false
    }
  },
  computed: {
    ...mapState('auth', ['loggingIn', 'loginError', 'loginSuccessful']),
    logoUrl() {
      return `${process.env.BASE_URL}images/logo_text_bottom.png`
    }
  },
  methods: {
    ...mapActions('auth', ['doSignup', 'doLogin']),
    async signupSubmit() {
      this.loading = true
      if (validateEmail(this.email)) {
        return this.doSignup({
          // firstName: this.firstName,
          // lastName: this.lastName,
          email1: this.email,
          username: this.username,
          password: this.password,
          userType: this.managerAccount,
          contactNumber1: this.phone
        }).then((response) => {
          this.loading = false
          if (response.success) {
            this.loginSubmit()
            // this.$router.replace('/dashboard')
          } else {
            this.snackbar = true
            this.snackMessage = response.message
          }
        })
      } else {
        this.snackbar = true
        this.snackMessage = 'Please provide a valid email address.'
      }
    },
    loginSubmit() {
      return this.doLogin({
        username: this.username,
        password: this.password
      }).then((response) => {
        if (response) {
          // this.$router.go()
          window.location.reload()
          // this.$router.replace('/dashboard')
        }
      })
    },
    openTermsAndConditions() {
      this.$refs.termsAndConditions.open()
    },
    openPrivacyPolicy() {
      this.$refs.privacyPolicy.open()
    },
    redirectLogin() {
      this.$router.replace('/login')
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.$router.replace('/login')
    }
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase())
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
.login {
  /*background-image: `url(${process.env.BASE_URL}images/cover_img_1.jpg)`;*/
  height: 100%;
}
.v-card {
  border-radius: 12px !important;
}
.v-menu__content {
  border-radius: 20px !important;
}
p {
  margin-bottom: 0;
}
.v-form {
  max-width: 350px;
}
.link {
  padding-top: 20px;
  text-align: center;
}
.link a {
  text-decoration: none;
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
}
.subtitle-2 {
  letter-spacing: 3px;
}
</style>
